import { get_shici_one, get_shici_random_one } from "@/api/shici";
import { get } from "@vueuse/shared";
import { onMounted, reactive, toRefs, nextTick } from "vue"; //文本断句

const duanJu = /(?<=[；。？！])\B/g;
/** 动画时间，用于计算文字飞行的速度 */

const aniTime = 2000 / 60;
export default {
  name: "about_name",

  setup() {
    /** 这里是定时器 */
    let timer = null;
    let shici = reactive({
      title: null,
      name: null,
      year: null,
      text: []
    }); //挂载生命周期

    onMounted(() => {
      document.title = '每日诗词';
      get_shici_one().then(res => {
        console.log("请求结果");
        console.log(res);
        shici.text = res.text.split(duanJu);
        shici.name = res.name;
        shici.year = res.year;
        shici.title = res.title;
        console.log(shici.text);
      }).catch(err => {
        console.log(err);
      });
    }); //获取随机一首诗

    function get_random_one() {
      clearInterval(timer);
      let aniMoveList = document.querySelectorAll('.moveAni');
      aniMoveList.forEach(i => i.remove());
      console.log("切诗");
      get_shici_random_one().then(res => {
        console.log("请求结果");
        console.log(res);
        shici.text = res.text.split(duanJu);
        shici.name = res.name;
        shici.year = res.year;
        shici.title = res.title;
        console.log(shici.text);
        nextTick(txtMoveAni);
      });
    }
    /** 文字移动动画 */


    function txtMoveAni() {
      let context = document.getElementById("context");
      context.style.opacity = 0;
      let newContext = context.cloneNode(true);
      newContext.id = 'copy'; // Object.assign(newContext,context)

      console.log(newContext);
      let title = newContext.children[0].innerHTML;
      title = title.split('').map(item => {
        return `<span class="moveAni">${item}</span>`;
      });
      newContext.children[0].innerHTML = title.join('');
      let name = newContext.children[1].children[1].innerHTML;
      name = name.split('').map(item => {
        return `<span class="moveAni">${item}</span>`;
      });
      newContext.children[1].children[1].innerHTML = name.join('');
      let year = newContext.children[1].children[0].innerHTML;
      year = year.split('').map(item => {
        return `<span class="moveAni">${item}</span>`;
      });
      newContext.children[1].children[0].innerHTML = year.join('');

      for (let i = 0; i < newContext.children[2].children.length; i++) {
        let txt = newContext.children[2].children[i].innerHTML;
        txt = txt.split('').map(item => {
          return `<span class="moveAni">${item}</span>`;
        });
        newContext.children[2].children[i].innerHTML = txt.join('');
      }

      let moveAniDiv = document.getElementById("moveAniDiv");
      moveAniDiv.appendChild(newContext);
      nextTick(playAni);
    }

    function playAni() {
      let PlistPos = [];
      const pList = document.querySelectorAll('.moveAni'); // console.log(23,pList[0].style)

      const root = document.querySelectorAll('.root')[0];
      pList.forEach(item => {
        let tempPos = [getElementLeft(item), getElementTop(item)]; // item.style.setProperty('color','red')
        // item.style.setProperty('position','fixed')

        let newItem = item.cloneNode(true);
        let randomX = Math.random() * window.screen.width;
        let randomY = Math.random() * window.screen.height;
        root.appendChild(newItem);
        let speedX = Math.abs((tempPos[0] - randomX) / aniTime);
        let speedY = Math.abs((tempPos[1] - randomY) / aniTime);
        speedX = speedX < 1 ? 1 : speedX;
        speedY = speedY < 1 ? 1 : speedY;
        tempPos.push(speedX, speedY);
        PlistPos.push(tempPos); // item.remove()

        newItem.style.setProperty('position', 'absolute');
        newItem.style.setProperty('left', randomX + 'px');
        newItem.style.setProperty('top', randomY + 'px'); // console.log(randomX,randomY)
      }); // console.log(PlistPos)

      document.getElementById("copy").remove();
      clearInterval(timer); // console.log(PlistPos)

      timer = setInterval(() => {
        const moveAniList = document.querySelectorAll('.moveAni');
        let isChange = false;
        moveAniList.forEach((item, key) => {
          let curX = getElementLeft(item);

          if (curX - PlistPos[key][0] > PlistPos[key][2]) {
            item.style.setProperty('left', curX - PlistPos[key][2] + 'px');
            isChange = true;
          } else if (curX - PlistPos[key][0] < -PlistPos[key][2]) {
            item.style.setProperty('left', curX + PlistPos[key][2] + 'px');
            isChange = true;
          } else if (curX - PlistPos[key][0] == 0) {} else {
            item.style.setProperty('left', PlistPos[key][0] + 'px');
            isChange = true;
          }

          let curY = getElementTop(item);

          if (curY - PlistPos[key][1] > PlistPos[key][3]) {
            item.style.setProperty('top', curY - PlistPos[key][3] + 'px');
            isChange = true;
          } else if (curY - PlistPos[key][1] < -PlistPos[key][3]) {
            item.style.setProperty('top', curY + PlistPos[key][3] + 'px');
            isChange = true;
          } else if (curY - PlistPos[key][1] == 0) {} else {
            item.style.setProperty('top', PlistPos[key][1] + 'px');
            isChange = true;
          }
        });

        if (!isChange) {
          clearInterval(timer);
          moveAniList.forEach(item => item.remove());
          let context = document.getElementById("context");
          context.style.opacity = 255;
        }
      }, 1000 / 30); // console.log(getElementLeft(pList[0]),getElementTop(pList[0]))
    }

    function getElementTop(element) {
      var actualTop = element.offsetTop; //这是获取元素距父元素顶部的距离

      var current = element.offsetParent; //这是获取父元素

      while (current !== null) {
        //当它上面有元素时就继续执行
        actualTop += current.offsetTop; //这是获取父元素距它的父元素顶部的距离累加起来

        current = current.offsetParent; //继续找父元素
      }

      return actualTop;
    }

    function getElementLeft(element) {
      var actualLeft = element.offsetLeft; //这是获取元素距父元素顶部的距离

      var current = element.offsetParent; //这是获取父元素

      while (current !== null) {
        //当它上面有元素时就继续执行
        actualLeft += current.offsetLeft; //这是获取父元素距它的父元素顶部的距离累加起来

        current = current.offsetParent; //继续找父元素
      }

      return actualLeft;
    }

    return { ...toRefs(shici),
      get_random_one
    };
  }

};